// extracted by mini-css-extract-plugin
module.exports = {"only-mobile":"MaxWidthContainer_only-mobile__inh6x","only-desktop":"MaxWidthContainer_only-desktop__Bl7_P","root":"MaxWidthContainer_root__ZrWnA"};